import { ICompte, ICompteChangeEmailReturn, ICompteChangeLoginEnvoiMail, ICompteReturn, ICompteUpdateModules, IComptesExportReturn, IComptesReturn} from '../../../../models/interfaces/ICompte';
import { ServiceApplication_Key } from "../../../../config/helpers";
import { apiSlice } from "../../api";

import { IFilterCompteBODTO } from '../../../../models/interfaces/IFilterCompteBO';


export interface compteApiQueryBody {
  Application_Key: string;
  // eslint-disable-next-line
  Values: any;
}

export const compteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBOCompte: builder.query<ICompteReturn, string>({
      query: (Id: string) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values:{ Id: Id },
        };

        return {
          url: "/BO/Compte/Compte_Get",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchBOComptes: builder.query<IComptesReturn, IFilterCompteBODTO|undefined>({
      query: (obj) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/BO/Compte/Compte_GetAll",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchBOComptesToExport: builder.query<IComptesExportReturn, IFilterCompteBODTO|undefined>({
      query: (obj) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/BO/Compte/Compte_GetAll_ToExport",
          method: "POST",
          body: body,
        };
      },
    }),
    compteLoginCreateBO: builder.mutation<ICompteReturn, ICompte>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Compte/Compte_LoginCreate",
          method: "POST",
          body: body,
        };
      },
    }),
    updateCompteBO: builder.mutation<ICompteReturn, ICompte>({
      query: (data) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Compte/Compte_Update",
          method: "POST",
          body: body,
        };
      },
    }),
    UpdateCompteBOModules: builder.mutation<ICompteReturn, ICompteUpdateModules>({
      query: (data:ICompteUpdateModules) => {
        const body: compteApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Compte/Compte_UpdateModules",
          method: "POST",
          body: body,
        };
      },
    }),
    compteChangeLoginEnvoiMailBO: builder.mutation<ICompteChangeEmailReturn, ICompteChangeLoginEnvoiMail>({
          query: (data) => {
            const body: compteApiQueryBody = {
              Application_Key: ServiceApplication_Key,
              Values: {Login : data.Login, NewLogin: data.NewLogin},
            };
            return {
              url: "/BO/Compte/Compte_ChangeLoginEmail_EnvoiMail",
              method: "POST",
              body: body,
            };
          },
        }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFetchBOCompteQuery,
  useFetchBOComptesQuery,
  useLazyFetchBOComptesToExportQuery,
  useCompteLoginCreateBOMutation,
  useUpdateCompteBOMutation,
  useUpdateCompteBOModulesMutation,
  useCompteChangeLoginEnvoiMailBOMutation
} = compteApi;
